export const QueryKeyTypes = {
    address: 'address',
    hcp: 'hcp',
    ecg: 'ecg',
    role: 'role',
    note: 'note',
    chart: 'chart',
    client: 'client',
    patient: 'patient',
    summary: 'summary',
    pathway: 'pathway',
    profile: 'profile',
    userRole: 'userRole',
    reminder: 'reminder',
    hospital: 'hospital',
    discharge: 'discharge',
    nextOfKin: 'nextOfKin',
    parameter: 'parameter',
    staticList: 'staticList',
    genericLog: 'genericLog',
    biometrics: 'biometrics',
    watchConfig: 'watchConfig',
    supportTeam: 'supportTeam',
    examination: 'examination',
    userPathway: 'userPathway',
    userProperty: 'userProperty',
    healthRecord: 'healthRecord',
    notification: 'notification',
    authentication: 'authentication',
    healthActivities: 'healthActivities',
    networkSuggestions: 'networkSuggestions',
    appConfiguration: 'appConfiguration',
    generalPractitioner: 'generalPractitioner',
    additionalNotifyMethod: 'additionalNotifyMethod',
}
